<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Chelsea Esquivel is a born and raised Texas girl with a snappy attitude. Her love of animals started in utero. This love has deepened like fine wine or good cheese; so much so that she has said on too many occasions, she prefers animals to humans. Her husband’s main worry is that she will bring home another pet. Their current household is only three dogs…so far.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?5b326ab8